// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const glassPaneStack = defineModel({
  id: "glass-pane-stack",
  batchId: "future",
  name: "Glass-pane stack",
  tags: ["scenery","glass","pane","stack","low-poly","age-of-mcp","future"],
  summary: "Sheets of glass — windows, glazing and instruments.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.5, 0.06, 0.2), color: "#7a5a36", position: [0, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.2), color: "#6b4e2e", position: [-0.25, 0.17, 0], rotation: [0, 0, -0.12] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.2), color: "#6b4e2e", position: [0.25, 0.17, 0], rotation: [0, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.018, 0.36, 0.17), color: "#bcd6dd", position: [-0.12, 0.24, 0], rotation: [0, 0, -0.1] },
      { geometry: new THREE.BoxGeometry(0.018, 0.36, 0.17), color: "#a9c8d1", position: [-0.04, 0.24, 0], rotation: [0, 0, -0.08] },
      { geometry: new THREE.BoxGeometry(0.018, 0.36, 0.17), color: "#bcd6dd", position: [0.04, 0.24, 0], rotation: [0, 0, -0.06] },
      { geometry: new THREE.BoxGeometry(0.018, 0.36, 0.17), color: "#a9c8d1", position: [0.12, 0.24, 0], rotation: [0, 0, -0.04] },
    ],
  animations: [],
});
